export const enum EnumModeloAutenticacao {
    NumeroCartao = '0',
    NumeroCartaoSenha = '1',
    DocumentoCliente = '2',
}